import * as React from 'react'
import { SectionContainer } from './StyleComponents'
import { Text, StackChildren, Colors } from '@doordash/design-language'
import { MaskedSafetyImage } from './images'
import { safetyCourse as t } from './strings'
import { ImageContainer } from './styles'
import { Modal } from '@doordash/component-modal'
import Button from '@doordash/component-button'
import { Interpolate } from '@doordash/lib-i18n'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'
import * as events from '../../../events'
import { connect } from 'react-redux'
import * as DA from '../../../typeModules/events'
import { ANDROID_CLOSE_DEEPLINK, IOS_CLOSE_DEEPLINK } from '../../../constants'

type ActiveDasherSplashProps = {
  remainingDays: number
  onClick: any
  track?: (
    actions: DA.EventActions,
    name: DA.SafetyCourseSections
  ) => Promise<any>
}
const os = detectWebviewOs()
const isWebview = detectWebviewOs() !== OsTypes.NONE

const ActiveDasherSplash: React.FC<ActiveDasherSplashProps> = ({
  remainingDays,
  onClick,
  track,
}) => {
  React.useEffect(() => {
    track(DA.EventActions.Rendered, DA.SafetyCourseSections.ActiveDasherSplash)
  }, [track])

  return (
    <Modal
      hasCloseButton={false}
      shouldStackButtons
      isFullScreenOnMobile
      isFooterFixedPosition
      renderFooterContent={() => (
        <StackChildren>
          {remainingDays <= 30 && remainingDays > 0 && (
            <Text
              textAlign={Text.TextAlignments.Center}
              styles={Text.Styles.Medium16}
              color={Colors.SystemGrey60}
            >
              <Interpolate
                i18n={i18n}
                i18nKey={i18nKeys.safetyCourse__splash__remainingDays}
                values={{ days: t.day(remainingDays) }}
                components={[
                  <Text
                    weight={Text.Weights.Bold}
                    display={Text.DisplayModes.Inline}
                    color={Colors.SystemRed60}
                  />,
                ]}
              />
            </Text>
          )}

          <Button
            onClick={() => {
              track(
                DA.EventActions.Continue,
                DA.SafetyCourseSections.ActiveDasherSplash
              )
              onClick()
            }}
          >
            {remainingDays === 0 ? t.primaryButton() : t.continue()}
          </Button>
          {isWebview && remainingDays > 0 && (
            <Button
              type={Button.Types.FlatSecondary}
              onClick={() => {
                track(
                  DA.EventActions.Close,
                  DA.SafetyCourseSections.ActiveDasherSplash
                )
                return window.location.assign(
                  os === OsTypes.iOS
                    ? IOS_CLOSE_DEEPLINK
                    : ANDROID_CLOSE_DEEPLINK
                )
              }}
            >
              {t.remindMeLater()}
            </Button>
          )}
        </StackChildren>
      )}
    >
      <SectionContainer>
        <ImageContainer>
          <MaskedSafetyImage />
        </ImageContainer>
        <Text styles={Text.Styles.Bold22}>
          {remainingDays > 0
            ? t.title()
            : t.sections.activeSplash.requiredTitle()}
        </Text>
        {remainingDays === 0 && (
          <Text styles={Text.Styles.Bold16}>
            {t.sections.activeSplash.description2()}
          </Text>
        )}
        <Text styles={Text.Styles.Medium16} color={Colors.TextTertiary}>
          {t.sections.activeSplash.description1()}
        </Text>
        {remainingDays > 0 && (
          <Text styles={Text.Styles.Bold16}>
            {t.sections.activeSplash.description2()}
          </Text>
        )}
        <Text styles={Text.Styles.Medium16} color={Colors.TextTertiary}>
          {t.sections.activeSplash.description3()}
        </Text>
      </SectionContainer>
    </Modal>
  )
}

const mapDispatchToProps = {
  track: events.trackSafetyCourse,
}
export default connect(null, mapDispatchToProps)(ActiveDasherSplash)
